import React from 'react';
import { useParams } from 'react-router-dom';

function UserProfilePage() {
  const { userId } = useParams();
  return <h2 className="text-2xl font-bold mb-4">User Profile Page for User ID: <span className="text-blue-500">{userId}</span></h2>;
}

export default UserProfilePage;